import type { MediaPlayerSeekSegment } from "../../media-player/media-player-seek-bar";
import { resolveSegmentRegionAtPercent } from "../../media-player/media-player-track-segment-tooltip";

export function mapInteractiveSegmentsToSeekSegments(
	segments: readonly {
		startPercent: number;
		label?: string;
		cardIndex?: number;
	}[],
): MediaPlayerSeekSegment[] {
	return segments.map((segment, index) => ({
		percent: segment.startPercent,
		label: segment.label ?? `Segment ${index + 1}`,
		cardIndex: segment.cardIndex ?? index,
	}));
}

export function resolveInteractiveAudioAriaValueText(
	playheadPercent: number,
	segments: readonly { startPercent: number; label?: string }[],
): string | undefined {
	const seekSegments = mapInteractiveSegmentsToSeekSegments(segments);
	const region = resolveSegmentRegionAtPercent(playheadPercent, seekSegments);
	if (region == null) {
		return undefined;
	}
	const index =
		[...seekSegments]
			.sort((a, b) => a.percent - b.percent)
			.findIndex((segment) => segment.percent === region.startPercent) +
		1;
	return `Segment ${index} of ${seekSegments.length}: ${region.label}`;
}
